var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meta-block"},[_c('h4',{staticClass:"meta-subtitle"},[_vm._v("Item Metadata")]),_c('KeyValueList',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }